<template>
  <div class="new-transaction">
    <h2 class="title">{{ $t('transactions.editTitle') }}</h2>

    <div v-if="error" class="notification is-danger">
      {{ error }}
    </div>

    <transaction-form
            v-if="transaction"
      :transaction="transaction"
      :submit-callback="update"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TransactionForm from './TransactionForm'

export default {
  name: 'edit-transaction',
  components: {
    TransactionForm
  },
  data () {
    return {
      transaction: null,
      error: null
    }
  },
  created () {
    this.loadTransaction()
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    async update () {
      try {
        await this.$store.dispatch('transactions/update', this.transaction)
      } catch (error) {
        this.error = error.response.data.message
      }

      this.$store.commit('showAlertBar', { text: this.$t('transactions.updateSuccessMessage'), type: 'success' })

      this.$router.push('/transactions')
    },
    async loadTransaction () {
      const response = await this.$store.dispatch('transactions/get', this.$route.params.id)
      this.transaction = response.data
    }
  }
}
</script>

<style scoped>

</style>
